import React, { Component } from 'react'
import styled from 'styled-components'
import { pxToRem, color } from '../../utils'
import PdfIcon from '../../assets/icons/iconPdf.svg'

const Content = styled.div`
  border-radius: ${pxToRem('7px')};
  background-color: ${color.primary};
  border: 1px solid ${color.primary};
  padding: ${pxToRem('10')} 0;
  font-family: 'Open Sans', sans-serif;
  text-transform: uppercase;
  font-size: ${pxToRem('16px')};
  text-align: center;
  color: #ffffff;
  transition: .2s;
  cursor: pointer;
  display: block;
  width: 300px;
  &:hover,
  &:focus {
    box-shadow: 0 0 ${pxToRem('15px')} 0 ${color.secondary};
    outline: none;
  }
  &:active {
    box-shadow: inset 0 0 ${pxToRem('5px')} 0 ${color.secondary};
    border-color: ${color.secondary};
  }
  &:disabled {
    opacity: 0.6;  
  }
  label {
    cursor: pointer;
    display: flex;
    justify-content: center;
    img {
      cursor: pointer;
      width: 16px;
      height: 16px;
      margin: 0px 5px;
    }
  }
`

const Input = styled.input`
  display: none;
`

class InputFile extends Component {
  constructor(props) {
    super(props)
    this.inputFile = React.createRef()

    this.state = {
      fileName: ''
    }
  }

  componentDidMount() {
    const { autoFocus } = this.props

    if (autoFocus && this.inputRef.current) {
      this.inputRef.current.focus()
    }
  }

  onInputChange = event => {
    this.setState({fileName: `${event.target.files[0].name}`})
    this.props.onChange(event)
  }

  render() {
    const { label = 'Escolha seu arquivo PDF', 
            value, 
            type = 'file', 
            display = 'block', 
            width = '100%', 
            margin = '0px',
            ...rest 
          } = this.props
    return (
      <Content>
        <label className="input-button">
        <div>{label}</div>
        <img id="img-button" src={PdfIcon} alt="Upload PDF Icon" />
        <Input ref={this.inputFile} onChange={this.onInputChange} type={type} {...rest} />
        </label>
        {this.state.fileName}    
      </Content>
    )
  }
}

export default InputFile


// WEBPACK FOOTER //
// ./src/components/Form/InputFile.js